import { useEditor } from "slate-react"
import React, { useRef } from "react"
import { Element, Node, Transforms, createEditor, Editor, Path } from "slate"
import { useDrop, useDrag } from "react-dnd"
import { EditablePhoto } from "./PhotoLayout"
import { moveImage } from "../../libs/EditorImages"

type Props = {
  id: string
  url: string
  thumbnail: string
  caption?: string
  wrapped?: "main" | "sub"
} & EditablePhoto

const DND_GROUP = "photo"

interface DragItem {
  type: string
  id: string
}

export const FigurePhoto: React.FunctionComponent<Props> = ({
  id,
  url,
  thumbnail,
  caption,
  editable,
  wrapped
}) => {
  const ref = useRef<HTMLImageElement>(null)
  if (editable) {
    const editor = useEditor()
    const [, drop] = useDrop({
      accept: DND_GROUP,
      hover(item: DragItem) {
        // nothing
        if (!ref.current || id === item.id) {
          return
        }
        moveImage(editor, id, item.id)
      },
      drop(item: DragItem) {
        if (!ref.current || id === item.id) {
          return
        }
        moveImage(editor, id, item.id)
      }
    })
    const [, drag] = useDrag({
      item: { type: DND_GROUP, id }
    })

    drag(drop(ref))
  }
  const figure = (
    <figure>
      <a
        href={url}
        onClick={e => {
          e.preventDefault()
          e.stopPropagation()
        }}
        itemType="http://schema.org/Photograph"
        itemScope
      >
        <img
          ref={ref}
          className="magnifiable"
          src={thumbnail}
          itemProp="image"
        ></img>
      </a>
      {caption && <figcaption>{caption}</figcaption>}
    </figure>
  )
  switch (wrapped) {
    case "main":
      return <div className="bl-photo__main-container__photo">{figure}</div>
    case "sub":
      return <div className="bl-photo__sub-container__photo">{figure}</div>
    default:
      return figure
  }
}
